import * as React from "react";
import { useTranslation } from "react-i18next";
import ActionDropdown from "views/components/common/ActionDropdown";
import { IconButton, Spinner } from "components/common";
const AggregationWidgetExportDropdown = ({
  children,
  isExporting
}) => {
  const { t } = useTranslation("enterprise_search");
  if (isExporting) return /* @__PURE__ */ React.createElement(Spinner, { text: "" });
  const widgetActionDropdownCaret = /* @__PURE__ */ React.createElement(IconButton, { name: "download", title: t("aggregation_widget_export_dropdown.export_widget"), showTooltip: false });
  return /* @__PURE__ */ React.createElement(ActionDropdown, { element: widgetActionDropdownCaret, header: t("aggregation_widget_export_dropdown.export_to_file") }, children);
};
export default AggregationWidgetExportDropdown;
